export const FLEXIBLE_CONTENT_BASE_SPACING = 5 as const

export const FLEXIBLE_CONTENT_LARGE_SPACING = 8 as const